import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { map } from "rxjs/operators";
import { BaseControlComponent } from "../../../../../../form-controls/components/base-control/base-control.component";
import { ContextInteractionService } from "../../../../../../form-controls/services/context-interaction.service";
import { DocumentManagementService } from "../../../../../../common/services/document-management.service";
import { OnBaseDocumentType } from "../../../../../../common/models/onBaseIntegrationAndMapping.model";

@Component({
    selector: "app-payment-response-data-config",
    templateUrl: "./payment-response-data-config.component.html",
    standalone: false
})
export class PaymentResponseDataConfigComponent extends BaseControlComponent implements OnInit, OnDestroy {
    static componentName = "PaymentResponseDataConfigComponent";

    invoiceTypes: OnBaseDocumentType[];
    receiptTypes: OnBaseDocumentType[]
    selectedInvoiceType: string;
    selectedReceiptType: string;
    selectType: OnBaseDocumentType = { id: -1, name: "--Select--" };

    subscription: Subscription = new Subscription();

    constructor(public readonly contextService: ContextInteractionService, private readonly _docService: DocumentManagementService) { super(contextService); }

    ngOnInit() {
        this.ensureConfig();
        const types$ = this._docService.getAllDocumentTypes().pipe(
            map((types: OnBaseDocumentType[]) => {
                return types.filter(t => t.name.toLocaleLowerCase().includes("rics"));
            })
        ).subscribe(
            (ricsTypes: OnBaseDocumentType[]) => {
                this.invoiceTypes = ricsTypes.filter(t => t.name.toLocaleLowerCase().includes("invoice"));
                this.receiptTypes = ricsTypes.filter(t => t.name.toLocaleLowerCase().includes("receipt"));
                this.invoiceTypes.unshift(this.selectType);
                this.receiptTypes.unshift(this.selectType);
                if (this.componentData.config.receiptType != null) {
                    this.selectedReceiptType = this.componentData.config.receiptType.name;
                }
                if (this.componentData.config.invoiceType != null) {
                    this.selectedInvoiceType = this.componentData.config.invoiceType.name;
                }
            },
            (error) => { console.error(error); }
        );
        this.subscription.add(types$);
    }

    ngOnDestroy() {
        super.ngOnDestroy();
        if (this.subscription != null) this.subscription.unsubscribe();
    }

    ensureConfig(): void {
        if (!this.componentData.config) {
            this.componentData.config = {
                payments: "",
                paymentAddress: "",
                receiptType: this.selectType,
                invoiceType: this.selectType
            }
        }
        if (this.componentData.config.receiptType == null) {
            this.componentData.config.receiptType = this.selectType;
        }
        if (this.componentData.config.invoiceType == null) {
            this.componentData.config.invoiceType = this.selectType;
        }
    }

    invoiceTypeChanged(evt: string): void {
        const selected = this.invoiceTypes.find(i => i.name.toLocaleLowerCase() === evt.toLocaleLowerCase());
        this.componentData.config.invoiceType = selected;
    }

    receiptTypeChanged(evt: string): void {
        const selected = this.receiptTypes.find(i => i.name.toLocaleLowerCase() === evt.toLocaleLowerCase());
        this.componentData.config.receiptType = selected;        
    }
}
